import React from 'react';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';

export type A2PinnedAlertCardParams = DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type A2PinnedAlertCardProps = RenderingProps<unknown, A2PinnedAlertCardParams>;

export const Default = (props?: A2PinnedAlertCardProps): JSX.Element => {
  return (
    <div
      className={`component ${props?.params?.styles} ${translationClasses(props?.params)}`}
      id={props?.params?.AnchorLinkTargetName}
    >
      <div className="component-content">
        <p>A2PinnedAlertCard Component</p>
      </div>
    </div>
  );
};
